import { FC } from 'react';
import { CatalogDestination } from './components/catalogDestination';

interface DestinationsProps {}


export const DestinationsV2: FC<DestinationsProps> = () => {
  
  return (
    <CatalogDestination></CatalogDestination>
  );
};
